import {Desk} from "../../../api/Model";
import {RemoteValue} from "../../../util/RemoteValue";
import {useCreateAndOpenSeatingPlan, useUnassignDesks} from "../useFixDeskAssignments";
import {Typography} from "@mui/material";
import {useConfirm} from "material-ui-confirm";
import {useMemo} from "react";

export function useFixDesksAssignedToInactiveEmployees(problems: RemoteValue<Desk[]>) {
    const confirm = useConfirm();
    const createAndOpenSeatingPlan = useCreateAndOpenSeatingPlan();
    const unassignDesks = useUnassignDesks();

    return useMemo(() => createAndOpenSeatingPlan && (async () => {
        const {confirmed} = await confirm({
            title: 'Create a fixing seating plan?',
            description: (
                <Typography>
                    After you create the seating plan unassigning desks from inactive employees,
                    you will be able to <b>review and correct</b> the proposed changes
                    and <b>apply the seating plan</b> once you are satisfied with the changes.
                </Typography>
            ),
            confirmationText: 'Create seating plan',
            confirmationButtonProps: {variant: 'contained'},
        });
        if (!confirmed) return;

        await createAndOpenSeatingPlan(
            {
                name: 'Unassign desks from inactive employees',
                description: 'Proposed fixes for desks assigned to inactive employees.',
            },
            async seatingPlan => unassignDesks(seatingPlan, await problems.value),
        );
    }), [confirm, createAndOpenSeatingPlan]);
}
